import { tva } from '@gluestack-ui/utils/nativewind-utils';
import { isWeb } from '@gluestack-ui/utils/nativewind-utils';
const baseStyle = isWeb ? 'flex flex-col relative z-0' : '';

export const cardStyle = tva({
  base: baseStyle,
  variants: {
    size: {
      sm: 'p-3 rounded-md',
      md: 'p-4 rounded-md',
      lg: 'p-6 rounded-md',
    },
    variant: {
      elevated: 'bg-surface-base',
      outline: 'border border-outline-default ',
      ghost: 'rounded-none',
      filled: 'bg-surface-raised',
    },
  },
});
